"use strict";
import React, { Component, ReactNode, useState } from "react";
import {
  Platform,
  Text,
  View,
  ActivityIndicator,
  UIManager,
  LayoutAnimation,
  TouchableHighlight,
  Pressable,
} from "react-native";
import { BlurView } from "@react-native-community/blur";
import Modal, { ModalProps } from "react-native-modal";
import { RectButton } from "react-native-gesture-handler";
import {
  StyleSheet,
  Spinner,
  Theme,
  Actionable,
  TurboSymbol,
  ScaledButton,
} from "@app/ui";
import tinycolor from "tinycolor2";
//import { gestureHandlerRootHOC } from 'react-native-gesture-handler';

if (
  Platform.OS === "android" &&
  UIManager.setLayoutAnimationEnabledExperimental
) {
  UIManager.setLayoutAnimationEnabledExperimental(true);
}

interface Props {
  children?: ReactNode;
  onPress: Function;
  text?: string;
  isLoading?: boolean;
  backgroundColor?: string;
  textColor?: string;
  style?: any;
  containerStyle?: any;
  symbol?: string;
  disabled?: boolean;
}

interface State {
  isVisible: boolean;
  isLoading: boolean;
  backgroundColor: string;
}

const Button = ({
  children,
  onPress,
  text,
  isLoading,
  backgroundColor = Theme.colors.primary,
  textColor,
  style,
  containerStyle,
  symbol,
  disabled = false,
}: Props) => {
  // static getDerivedStateFromProps(props: Props, state: State) {
  //   if (props.isLoading !== state.isLoading) {
  //     LayoutAnimation.configureNext(
  //       LayoutAnimation.create(
  //         200,
  //         LayoutAnimation.Types.easeInEaseOut,
  //         LayoutAnimation.Properties.opacity
  //       )
  //     );
  //     return {
  //       isLoading: props.isLoading,
  //     };
  //   }
  //
  //   return null;
  // }

  const buttonHeight = 38;

  const renderLoading = () => {
    return <Spinner size="small" opacity={0.3} type="Pulse" />;
  };

  const renderChildren = () => {
    if (isLoading) {
      return renderLoading();
    }

    let finalBackgroundColor = isLoading ? "#cccccc" : backgroundColor;

    const color =
      textColor || tinycolor(finalBackgroundColor).isDark()
        ? "#ffffff"
        : "#000000";

    return (
      <View
        style={{
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {symbol && (
          <TurboSymbol
            color={color}
            name={symbol}
            size={18}
            style={{ marginRight: text ? 12 : 0, lineHeight: 38 }}
          />
        )}
        {text && (
          <Text
            style={{
              color: color,
              height: buttonHeight,
              lineHeight: buttonHeight + 3,
              textAlign: "center",
              fontSize: 14,
              fontFamily: Theme.fonts.titles.medium,
            }}
          >
            {text}
          </Text>
        )}
        {children}
      </View>
    );
  };

  let superBackgroundColor =
    isLoading || disabled ? "#cccccc50" : backgroundColor;

  // return (
  //   <Actionable
  //     onPress={props.onPress.bind(this)}
  //     style={{
  //       backgroundColor: backgroundColor, // superBackgroundColor, //this.state.appearance.colors.tertiary,
  //       height: 44,
  //       borderRadius: 4,
  //     }}
  //     highlightColor={superBackgroundColor}
  //   >
  //     {renderChildren()}
  //   </Actionable>
  // );

  return (
    <ScaledButton
      containerStyle={containerStyle}
      style={{
        backgroundColor: superBackgroundColor, //this.state.appearance.colors.tertiary,
        height: buttonHeight,
        borderRadius: 4,
        ...Platform.select({
          web: {
            cursor: "pointer",
          },
        }),
        ...style,
      }}
      onPress={onPress.bind(this)}
    >
      {renderChildren()}
    </ScaledButton>
  );

  if (Platform.OS === "android") {
    return (
      <TouchableHighlight
        onPress={onPress.bind(this)}
        style={{
          backgroundColor: superBackgroundColor, //this.state.appearance.colors.tertiary,
          height: buttonHeight,
          borderRadius: 4,
          ...style,
        }}
        underlayColor="#fff"
      >
        {renderChildren()}
      </TouchableHighlight>
    );
  } else {
    return (
      <Pressable
        style={{
          backgroundColor: superBackgroundColor, //this.state.appearance.colors.tertiary,
          height: buttonHeight,
          borderRadius: 4,
          ...Platform.select({
            web: {
              cursor: "pointer",
            },
          }),
          ...style,
        }}
        onPress={onPress.bind(this)}
      >
        {renderChildren()}
      </Pressable>
    );
  }
};

export default Button;
